// import Select from 'react-select';
// import useUsersList from 'hooks/API/GET/useUsersList';
// import { Fragment, useEffect, useState } from 'react';

// function UserDropDownMultiple({
//   enableAPI,
//   value,
//   handleChange,
//   dependencies = {},
//   fieldErrors = {},
// }) {
//   const { query = '' } = dependencies;
//   const [availableUser, setAvailableUser] = useState([]);
//   const [initialValue, setInitialValue] = useState([]);
//   const [apiRecord, setApiRecord] = useState([]);
//   const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;
//   const { data, isLoading, isError } = useUsersList({ enabled: enableAPI, queryParams });
//   const { errorMessage = '' } = fieldErrors;
//   useEffect(() => {
//     if (isLoading || !data) {
//       return;
//     }
//     const result = [];
//     setApiRecord(data.data);
//     data.data.map((option) => {
//       result.push({ value: option._id, label: option.name });
//       return option;
//     });
//     setAvailableUser(result);
//   }, [isLoading, data]);
//   useEffect(() => {
//     if (value && value.length > 0) {
//       setInitialValue(value);
//     }
//   }, [value]);
//   let selectBoxClasses = '';
//   if (errorMessage) {
//     selectBoxClasses = 'border border-danger';
//   }
//   function defaultValue(label) {
//     return [{ value: label, label: label, isDisabled: true }];
//   }
//   const updateDataChange = (event) => {
//     const result = [];
//     event.forEach((f) => {
//       const findValue = apiRecord.find((api) => api._id === f.value);
//       if (findValue) {
//         result.push(findValue._id);
//       }
//     });
//     handleChange(result);
//   };

//   return (
//     <Fragment>
//       <label>Select User</label>
//       {isLoading ? (
//         <Select options={defaultValue('Loading...')} className={selectBoxClasses} />
//       ) : isError ? (
//         <Select options={defaultValue('Failed to load list...')} className={selectBoxClasses} />
//       ) : (
//         <Fragment>
//           {data?.data?.length > 0 ? (
//             <Select
//               value={initialValue}
//               options={availableUser}
//               isMulti
//               className={selectBoxClasses}
//               onChange={(e) => updateDataChange(e)}
//             />
//           ) : (
//             <Select options={defaultValue('No options found...')} className={selectBoxClasses} />
//           )}
//         </Fragment>
//       )}
//     </Fragment>
//   );
// }

// UserDropDownMultiple.defaultProps = {
//   handleChange: () => {},
// };

// export default UserDropDownMultiple;

import Select from 'react-select';
import useUsersList from 'hooks/API/GET/useUsersList';
import { Fragment, useEffect, useState } from 'react';

function UserDropDownMultiple({
  enableAPI,
  value = [],
  handleChange,
  dependencies = {},
  fieldErrors = {},
}) {
  const { query = '' } = dependencies;
  const [availableUser, setAvailableUser] = useState([]);

  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;
  const { data, isLoading, isError } = useUsersList({
    enabled: enableAPI,
    queryParams,
  });

  const { errorMessage = '' } = fieldErrors;

  useEffect(() => {
    if (!data?.data) return;

    setAvailableUser(
      data.data.map((user) => ({
        value: user._id,
        label: user.name,
      }))
    );
  }, [data]);

  /** Convert stored IDs → select options */
  const selectedOptions = availableUser.filter((option) => value.includes(option.value));

  return (
    <Fragment>
      <label>Select User</label>

      <Select
        isMulti
        isLoading={isLoading}
        options={availableUser}
        value={selectedOptions}
        className={errorMessage ? 'border border-danger' : ''}
        onChange={(selected) => handleChange(selected ? selected.map((item) => item.value) : [])}
        noOptionsMessage={() => (isError ? 'Failed to load list...' : 'No options found...')}
      />
    </Fragment>
  );
}

UserDropDownMultiple.defaultProps = {
  handleChange: () => {},
};

export default UserDropDownMultiple;
